<script>
import TablePage from '@/found/components/table_page';
import Vue from 'vue';
import FormPage from '../form/form.vue';

export default {
  extends: TablePage,
  components: {
    // Modal,
    FormPage,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  mounted() {
    this.getConfigList('order-back-list');
  },

  methods: {
    clickVisible({ row, val: { code } }) {
      const { approveStatus } = row;
      // 待提交或者审批驳回需要显示按钮，即不隐藏。
      if (approveStatus && code === 'edit' && (approveStatus === '1' || approveStatus === '2')) {
        return false;
      }

      return true;
    },
    modalClick({ val, row }) {
      const formPageArg = {
        drawerTitle: '',
        code: val.code, // 按钮对应code
        id: '', // 数据code
        formShow: true,
      };
      if (val.code === 'add') {
        formPageArg.drawerTitle = '新增';
      }
      if (val.code === 'edit') {
        formPageArg.drawerTitle = '编辑';
        formPageArg.id = row.id;
      }
      if (val.code === 'view') {
        formPageArg.drawerTitle = '查看';
        formPageArg.id = row.id;
      }
      this.createFormPage(formPageArg);
    },
    createFormPage(arg) {
      const Component = Vue.extend(FormPage);
      const that = this;
      const vm = new Component({
        el: document.createElement('div'),
        data() {
          return {
            ...arg,
          };
        },
        methods: {
          getParentTable() {
            that.getConfigList('order-back-list');
          },
        },
      });
      document.body.appendChild(vm.$el);
    },
  },
};
</script>
